import React, { Component } from 'react';
import { Button, Input, Alert, Collapse } from 'reactstrap';
import ProductGroups from './ProductGroups';
import Product from './Product';
import '../ModifyProducts.css';

export class ModifyOneTimeCharge extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken');

    this.state = {
      activeCollapse: undefined,
      activeInnerNewCollapse: 0,
      activeTab: 'services',
    };
  }

  handleOpenCollapse = id => {
    const { activeCollapse } = this.state;
    const currentId = activeCollapse === id ? undefined : id;
    this.setState({ activeCollapse: currentId });
  };

  handleOpenNewCollapse = id => {
    const { activeInnerNewCollapse } = this.state;
    const currentId = activeInnerNewCollapse === id ? undefined : id;
    this.setState({ activeInnerNewCollapse: currentId });
  };

  render() {
    const {
      oneTimeCharge,
      editMode,
      productGroupsData,
      onFieldProductGroupsUpdate,
      onFieldProductUpdate,
      onOTCProductPriceUpdate,
      addProduct,
      deleteProduct,
      showDeleteModal,
      isNewProductGroups,
      setCreateMode,
      resetProductGroupsData,
      setEditData,
      updateOTCProductGroups,
      saveOTCProductGroups,
      deleteProductGroup,
    } = this.props;

    const { activeCollapse, activeInnerNewCollapse } = this.state;
    return (
      <div className="collapse-container">
        {oneTimeCharge.length ? (
          oneTimeCharge.map(
            (group, i) =>
              group?.type === 'equipment' && (
                <ProductGroups
                  key={i}
                  deleteProductGroup={deleteProductGroup}
                  activeCollapse={activeCollapse}
                  group={group}
                  editMode={editMode}
                  createMode={isNewProductGroups}
                  setEditData={setEditData}
                  currentId={productGroupsData._id}
                  onFieldProductGroupsUpdate={onFieldProductGroupsUpdate}
                  editData={productGroupsData}
                  updateOTCProductGroups={updateOTCProductGroups}
                  updateProductField={onFieldProductUpdate}
                  onOTCProductPriceUpdate={onOTCProductPriceUpdate}
                  addProduct={addProduct}
                  deleteProduct={productIndex => showDeleteModal(productIndex)}
                  openCollapse={this.handleOpenCollapse}
                />
              ),
          )
        ) : (
          <Alert color="info" style={{ margin: '20px' }}>
            No Product Groups Found
          </Alert>
        )}
        {isNewProductGroups && (
          <div className="product-groups-item">
            <div className="edit-name-product-container">
              <Input
                className="edit-input-product"
                name="groupName"
                value={productGroupsData.groupName}
                placeholder="Please enter product groups name"
                onChange={e =>
                  onFieldProductGroupsUpdate(e.currentTarget.name, e.currentTarget.value)
                }
              />
            </div>
            <div className="action-accordion-container">
              <Button color="success" onClick={saveOTCProductGroups}>
                Save
              </Button>
              <Button
                onClick={() => {
                  setCreateMode(false);
                  resetProductGroupsData();
                }}
              >
                Cancel
              </Button>
            </div>
            <div
              className={`product-groups-header${
                activeCollapse === oneTimeCharge.length ? ' product-groups-header_open' : ''
              }`}
              onClick={() => this.handleOpenCollapse(oneTimeCharge.length)}
            />
            <Collapse isOpen={activeCollapse === oneTimeCharge.length}>
              <div className="collapse-content">
                <div className="actions-product-container">
                  <Button
                    color="success"
                    onClick={() => {
                      this.setState(
                        { activeInnerNewCollapse: productGroupsData.products.length },
                        () => {
                          addProduct();
                        },
                      );
                    }}
                  >
                    Add Product
                  </Button>
                </div>
                {productGroupsData.products.length ? (
                  <div className="collapse-container">
                    {productGroupsData.products.map((item, i) => (
                      <Product
                        key={i}
                        product={item}
                        editMode
                        currentId
                        groupId
                        editData={productGroupsData}
                        productIndex={i}
                        updateProductField={onFieldProductUpdate}
                        onOTCProductPriceUpdate={onOTCProductPriceUpdate}
                        deleteProduct={deleteProduct}
                        indexOpen={activeInnerNewCollapse}
                        onToggleCollapse={this.handleOpenNewCollapse}
                      />
                    ))}
                  </div>
                ) : (
                  <Alert color="info">Product not found</Alert>
                )}
              </div>
            </Collapse>
          </div>
        )}
      </div>
    );
  }
}

export default ModifyOneTimeCharge;
